import { useState, useEffect, useCallback } from 'react';

const MAX_HISTORY = 10;
const STORAGE_KEY = 'miamsecur_search_history';

export const useSearchHistory = () => {
  const [history, setHistory] = useState<string[]>([]);

  // Charger depuis localStorage au montage
  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          setHistory(parsed);
        }
      }
    } catch {
      // Ignore parsing errors
    }
  }, []);

  // Ajouter une recherche (dédoublonnage + limite)
  const addToHistory = useCallback((term: string) => {
    const trimmed = term.trim().toLowerCase();
    if (!trimmed || trimmed.length < 2) return;
    
    setHistory(prev => {
      const updated = [trimmed, ...prev.filter(h => h !== trimmed)].slice(0, MAX_HISTORY);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  // Supprimer une entrée
  const removeFromHistory = useCallback((term: string) => {
    setHistory(prev => {
      const updated = prev.filter(h => h !== term);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  // Effacer tout
  const clearHistory = useCallback(() => {
    setHistory([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return { history, addToHistory, removeFromHistory, clearHistory };
};
